import {FormControl, InputLabel, OutlinedInput, Select} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import {useTheme} from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function FileSelector({filterLabel, types, typeFilter, setFilter}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const displayEventTypeFilter = () => {
    let _types = [];
    types?.sort((a, b) => a.sortOrder - b.sortOrder).map((type, idx) => {
      if (typeFilter.indexOf(parseInt(type.id, 10)) > -1) {
        _types.push(type.name);
      }
    });
    return _types;
  }

  function getStyles(item, items) {
    let inArray = items.indexOf(item.id) > -1;
    return {
      fontWeight: inArray ? theme.typography.fontWeightBold : theme.typography.fontWeightRegular
    }
  }

  const toggleFilterById = (id) => {
    let _eventTypeFilter = [...typeFilter];
    if (_eventTypeFilter.indexOf(parseInt(id, 10)) > -1) {
      _eventTypeFilter.splice(typeFilter.indexOf(parseInt(id, 10)), 1);
    } else {
      _eventTypeFilter = [...typeFilter, parseInt(id, 10)];
    }
    setFilter(_eventTypeFilter);
  }

  const mobileStyle = {
    width: '100%'
  };

  const desktopStyle = {
    width: '300px'
  };

  return (
    <>
      {types?.length > 0 && <FormControl sx={isMobile ? mobileStyle : desktopStyle}>
        <InputLabel
          style={{
            paddingRight: '10px',
            paddingBottom: '6px'
          }}
          id="event-category-selector">Filter {filterLabel}</InputLabel>
        <Select
          sx={{
            paddingRight: '25px',
            paddingTop: '12px',
            paddingBottom: '12px',
            borderRadius: '0'
          }}
          className={'d-inline'}
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          multiple
          value={displayEventTypeFilter()}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <em>View All</em>;
            }
            return selected.join(', ');
          }}
          input={<OutlinedInput label={`Filter ${filterLabel}`}/>}
          MenuProps={MenuProps}
        >
          {types.map((type) => (
            <MenuItem
              key={type.id}
              value={type.id}
              // style={getStyles(type, typeFilter)}
              onClick={(e) => {
                let _e = {...e};
                toggleFilterById(type.id);
              }}
            >
              <Checkbox checked={typeFilter.includes(type.id)}/>
              {type.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      }
    </>
  )
}